import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ce-beta-notification-dialog',
    templateUrl: './beta-notification-dialog.component.html',
    styleUrls: ['./beta-notification-dialog.component.scss'],
    standalone: false,
})
export class BetaNotificationDialog {
    constructor(public dialogRef: MatDialogRef<BetaNotificationDialog>) {}
    doNotShowCheck = false;

    dialogAction(goToBeta: boolean): void {
        this.dialogRef.close({ gotoBeta: goToBeta, doNotShow: this.doNotShowCheck });
    }
}
